import { render, staticRenderFns } from "./PendingEditRequestTestimonialsVisibilityValues.vue?vue&type=template&id=6eb7ec4d&"
import script from "./PendingEditRequestTestimonialsVisibilityValues.vue?vue&type=script&lang=js&"
export * from "./PendingEditRequestTestimonialsVisibilityValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports